import { useTheme as useEmotionTheme } from '@emotion/react';
import { useMemo } from 'react';
import { Color, resolveColor } from './colors';
import DEFAULT_THEME from './default';
import { ThemeConfig } from './theme';
import {
  resolveTypography,
  TypographyCSS,
  TypographyVariant,
} from './typography';

type ThemeHook = {
  theme: ThemeConfig;
  resolveTypography: (variant: TypographyVariant) => TypographyCSS;
  resolveColor: (color: Color) => string;
  resolveSpacing: (factor: number) => string;
};

const useTheme = (): ThemeHook => {
  const contextTheme = useEmotionTheme();
  const theme = (
    Object.keys(contextTheme).length > 0 ? contextTheme : DEFAULT_THEME
  ) as ThemeConfig;

  const _resolveTypography = useMemo(() => resolveTypography(theme), [theme]);
  const _resolveColor = useMemo(() => resolveColor(theme), [theme]);

  return {
    theme,
    resolveTypography: _resolveTypography,
    resolveColor: _resolveColor,
    resolveSpacing: (factor) => `${theme.spacing * factor}px`,
  };
};

export default useTheme;
